import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/cake.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4206a934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registration" }
const _hoisted_2 = { class: "form container" }
const _hoisted_3 = { class: "row margin-bottom-form-field" }
const _hoisted_4 = { class: "col-xs-12" }
const _hoisted_5 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_6 = { class: "row margin-bottom-form-field" }
const _hoisted_7 = { class: "col-xs-12" }
const _hoisted_8 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_9 = { class: "row margin-bottom-form-field" }
const _hoisted_10 = { class: "col-xs-12" }
const _hoisted_11 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_12 = {
  key: 0,
  class: "row margin-bottom-form-field"
}
const _hoisted_13 = { class: "col-xs-12" }
const _hoisted_14 = ["aria-expanded"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "country-dial" }
const _hoisted_17 = {
  key: 0,
  class: "country-dropdown"
}
const _hoisted_18 = { class: "country-search-wrap" }
const _hoisted_19 = { class: "country-options" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "country-option-name" }
const _hoisted_23 = { class: "country-option-dial" }
const _hoisted_24 = {
  key: 0,
  class: "country-empty"
}
const _hoisted_25 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_26 = {
  key: 1,
  class: "row margin-bottom-form-field"
}
const _hoisted_27 = { class: "col-xs-12" }
const _hoisted_28 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-xs-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "input-slot-image",
  src: _imports_0
}, null, -1))
const _hoisted_32 = { class: "col-xs-6" }
const _hoisted_33 = {
  key: 0,
  class: "registration-error",
  style: {"margin-left":"15px"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_35 = { class: "conditions" }
const _hoisted_36 = { class: "conditions-wrapper" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "conditions-text" }, [
  /*#__PURE__*/_createTextVNode("uslove/pravila korišćenja i pravila"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" o privatnosti *")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_40 = { class: "conditions-wrapper" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "conditions-text" }, "više od 18 godina *", -1))
const _hoisted_42 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_43 = { class: "conditions-wrapper" }
const _hoisted_44 = { class: "error-text" }
const _hoisted_45 = { class: "submit" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 1,
  class: "otp-step"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "otp-title" }, "Potvrda broja telefona", -1))
const _hoisted_49 = { class: "otp-description" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = { class: "otp-phone" }
const _hoisted_52 = ["value", "disabled", "onInput", "onKeydown", "onFocus"]
const _hoisted_53 = {
  key: 0,
  class: "registration-error otp-error"
}
const _hoisted_54 = { class: "error-text" }
const _hoisted_55 = {
  key: 1,
  class: "otp-loading"
}
const _hoisted_56 = { class: "otp-resend" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "success-modal" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "success-modal-message" }, "Nalog je uspešno kreiran. Proverite Vašu email adresu.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.step === 'form')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event)),
                    class: _normalizeClass(`tb ${_ctx.errors.firstName.length ? 'error' : ''}`),
                    type: "text",
                    placeholder: "Ime"
                  }, null, 2), [
                    [_vModelText, _ctx.form.firstName]
                  ]),
                  (_ctx.errors.firstName.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errors.firstName), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lastName) = $event)),
                    class: _normalizeClass(`tb ${_ctx.errors.lastName.length ? 'error' : ''}`),
                    type: "text",
                    placeholder: "Prezime"
                  }, null, 2), [
                    [_vModelText, _ctx.form.lastName]
                  ]),
                  (_ctx.errors.lastName.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errors.lastName), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.username) = $event)),
                    class: _normalizeClass(`tb ${_ctx.errors.username.length ? 'error' : ''}`),
                    type: "text",
                    placeholder: "Korisničko ime"
                  }, null, 2), [
                    [_vModelText, _ctx.form.username]
                  ]),
                  (_ctx.errors.username.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.errors.username), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.registerWithPhone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`phone-field ${_ctx.errors.phone.length ? 'error' : ''}`)
                      }, [
                        _createElementVNode("div", {
                          class: "country-picker",
                          ref: "countryPickerRef",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "country-trigger",
                            "aria-expanded": _ctx.isCountryDropdownOpen,
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCountryDropdown && _ctx.toggleCountryDropdown(...args)))
                          }, [
                            _createElementVNode("img", {
                              class: "country-flag",
                              src: _ctx.selectedCountryFlag,
                              alt: _ctx.selectedCountry.name,
                              width: "24",
                              height: "18"
                            }, null, 8, _hoisted_15),
                            _createElementVNode("span", _hoisted_16, "+" + _toDisplayString(_ctx.selectedCountry.dialCode), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["country-caret", { open: _ctx.isCountryDropdownOpen }])
                            }, null, 2)
                          ], 8, _hoisted_14),
                          (_ctx.isCountryDropdownOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _withDirectives(_createElementVNode("input", {
                                    ref: "countrySearchRef",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.countrySearch) = $event)),
                                    class: "country-search",
                                    type: "text",
                                    inputmode: "search",
                                    placeholder: "Pretraži državu...",
                                    autocomplete: "off",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                                    onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.closeCountryDropdown && _ctx.closeCountryDropdown(...args)), ["stop"]), ["esc"]))
                                  }, null, 544), [
                                    [_vModelText, _ctx.countrySearch]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries, (country) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: country.iso2,
                                      type: "button",
                                      class: _normalizeClass(["country-option", { active: country.iso2 === _ctx.selectedCountryIso2 }]),
                                      onClick: ($event: any) => (_ctx.selectCountry(country.iso2))
                                    }, [
                                      _createElementVNode("img", {
                                        class: "country-flag",
                                        src: _ctx.getCountryFlagUrl(country.iso2),
                                        alt: country.name,
                                        width: "24",
                                        height: "18"
                                      }, null, 8, _hoisted_21),
                                      _createElementVNode("span", _hoisted_22, _toDisplayString(country.name), 1),
                                      _createElementVNode("span", _hoisted_23, "+" + _toDisplayString(country.dialCode), 1)
                                    ], 10, _hoisted_20))
                                  }), 128)),
                                  (!_ctx.filteredCountries.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Nema rezultata"))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 512),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.phone) = $event)),
                          class: "phone-input",
                          type: "tel",
                          inputmode: "numeric",
                          autocomplete: "tel-national",
                          placeholder: "641234567",
                          onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onPhoneInput && _ctx.onPhoneInput(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.form.phone]
                        ])
                      ], 2),
                      (_ctx.errors.phone.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.errors.phone), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "alt-method-link",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.switchToEmail && _ctx.switchToEmail(...args)))
                      }, " Koristi email umesto telefona ")
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.email) = $event)),
                        class: _normalizeClass(`tb ${_ctx.errors.email.length ? 'error' : ''}`),
                        type: "email",
                        autocomplete: "email",
                        placeholder: "Email"
                      }, null, 2), [
                        [_vModelText, _ctx.form.email]
                      ]),
                      (_ctx.errors.email.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.errors.email), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "alt-method-link",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.switchToPhone && _ctx.switchToPhone(...args)))
                      }, " Koristi telefon umesto emaila ")
                    ])
                  ])),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_VueDatePicker, {
                    ref: "datePickerInput",
                    modelValue: _ctx.form.birthday,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.birthday) = $event)),
                    clearable: false,
                    placeholder: "DD-MM-YYYY",
                    "auto-apply": "",
                    "action-row": {
                showNow: false,
                showPreview: false,
                showSelect: false,
                showCancel: false,
              },
                    id: "birthday",
                    "enable-time-picker": false,
                    format: "dd-MM-yyyy"
                  }, {
                    "input-icon": _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.promoCode) = $event)),
                    class: "tb-half",
                    type: "text",
                    placeholder: "Promo kod"
                  }, null, 512), [
                    [_vModelText, _ctx.form.promoCode]
                  ])
                ]),
                (_ctx.errors.birthday.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.errors.birthday), 1))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_34
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.acceptedTerms) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.acceptedTerms]
                ]),
                _createTextVNode(" Prihvatam "),
                _hoisted_37,
                _hoisted_38,
                (_ctx.errors.acceptedTerms.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_39, " * Polje je obavezno "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.isAdult) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isAdult]
                ]),
                _createTextVNode(" Da, imam "),
                _hoisted_41,
                (_ctx.errors.isAdult.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, "* Polje je obavezno"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.agreedNotifications) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.agreedNotifications]
                ]),
                _createTextVNode(" Slažem se da primam promotivne poruke, i ponude putem email-a, SMS-a i drugih vidova komunikacije ")
              ])
            ]),
            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.getRegistrationErrorMessage), 1),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("button", {
                class: "btnSubmit",
                disabled: _ctx.isSubmittingAccount || _ctx.isLoadingCreateAccount,
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleCreateAccount()))
              }, _toDisplayString(_ctx.isSubmittingAccount || _ctx.isLoadingCreateAccount ? "Učitavanje..." : "Kreirajte nalog"), 9, _hoisted_46)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("p", _hoisted_49, [
              _createTextVNode(" Unesite 6-cifreni kod koji smo poslali na"),
              _hoisted_50,
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.fullPhoneNumber), 1)
            ]),
            _createElementVNode("div", {
              class: "otp-inputs",
              onPaste: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onOtpPaste && _ctx.onOtpPaste(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otpDigits, (_, index) => {
                return (_openBlock(), _createElementBlock("input", {
                  key: `${_ctx.otpInputsKey}-${index}`,
                  ref_for: true,
                  ref: (el) => _ctx.setOtpInputRef(el, index),
                  value: _ctx.otpDigits[index],
                  class: _normalizeClass(['otp-input', { error: Boolean(_ctx.otpError) }]),
                  type: "text",
                  inputmode: "numeric",
                  autocomplete: "one-time-code",
                  maxlength: "1",
                  disabled: _ctx.isLoadingCheckOtp,
                  onInput: ($event: any) => (_ctx.onOtpInput($event, index)),
                  onKeydown: ($event: any) => (_ctx.onOtpKeydown($event, index)),
                  onFocus: ($event: any) => (_ctx.onOtpFocus(index))
                }, null, 42, _hoisted_52))
              }), 128))
            ], 32),
            (_ctx.otpError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(_ctx.otpError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.getRegistrationErrorMessage), 1),
            (_ctx.isLoadingCheckOtp)
              ? (_openBlock(), _createElementBlock("p", _hoisted_55, "Provera koda..."))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                type: "button",
                class: "alt-method-link",
                disabled: _ctx.resendSecondsLeft > 0 || _ctx.isSubmittingAccount || _ctx.isLoadingCreateAccount || _ctx.isLoadingCheckOtp,
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleResendOtp && _ctx.handleResendOtp(...args)))
              }, [
                (_ctx.resendSecondsLeft > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Pošalji ponovo (" + _toDisplayString(_ctx.resendSecondsLeft) + "s) ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Pošalji kod ponovo")
                    ], 64))
              ], 8, _hoisted_57),
              _createElementVNode("button", {
                type: "button",
                class: "alt-method-link otp-back",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.backToForm && _ctx.backToForm(...args)))
              }, " Nazad na registraciju ")
            ])
          ]))
    ]),
    (_ctx.showSuccessModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "success-modal-overlay",
          onClick: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmRegistrationRedirect && _ctx.confirmRegistrationRedirect(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("button", {
              type: "button",
              class: "success-modal-btn",
              onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.confirmRegistrationRedirect && _ctx.confirmRegistrationRedirect(...args)))
            }, "Potvrdi")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}